import React from 'react';
import { ShowHostForm } from 'components/layout/forms';
import { PageWrapper2 } from 'components/modules/Wrapper2';
// import { home } from 'assets/images';
function ShowHostView() {
	return (
		<div className='bg-[#0E1022]'>
			<PageWrapper2>
				<div>
					<ShowHostForm />
				</div>
			</PageWrapper2>
		</div>
	);
}

export default ShowHostView;
